// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"b27e0511","239":"e39fb35b","455":"39cc1d1f","918":"57607279","977":"240addac"}[chunkId] + ".chunk.js";
};